import React, { useEffect, useRef } from 'react';

import Hls from 'hls.js';

const HLS_LIVE_CONFIG = {
  debug: false,
  enableWorker: true,
  lowLatencyMode: true,
  backBufferLength: 90,
  liveSyncDuration: 1.4,
  liveMaxLatencyDuration: 5,
  maxLiveSyncPlaybackRate: 1.2,
  liveDurationInfinity: true,
  startFragPrefetch: true,
};

const HLS_HISTORY_CONFIG = {
};

export const HLSVideoPlayer = ({ src, autoPlay, height, isArchive }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!src || !video) return () => {};

    const hlsConfig = isArchive ? HLS_HISTORY_CONFIG : HLS_LIVE_CONFIG;
    const hls = new Hls(hlsConfig);

    if (Hls.isSupported()) {
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.ERROR, console.error);
    } else if ((video.canPlayType('application/vnd.apple.mpegurl'))) {
      video.src = src;
    }

    return () => {
      if (Hls.isSupported()) {
        hls.destroy();
      }
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    };
  }, [src, isArchive]);

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/media-has-caption
    <video
      autoPlay={autoPlay}
      controls
      ref={videoRef}
      style={{ width: '100%', height: `${height ? '100%' : 'auto'}` }}
    />
  );
};
